// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A great explainer widget, used to display a sequence of images, each paired with related text.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Image-bar gallery",
  id: "imagebar-gallery",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/imagebar-gallery/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ImageBarGalleryConfigTool" */ "app/components/tools/ImageBarGalleryConfigTool/ImageBarGalleryConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ImageBarGalleryConfigTool"]
  })
};

export default CONFIG;
